// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iotzzkevshufpjgvxblv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlvdHp6a2V2c2h1ZnBqZ3Z4Ymx2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3NDM3MTQsImV4cCI6MjA2NjMxOTcxNH0.3QjSSBg13BhjNyTWX4YlYcxmGVsy1_Ppeco-5fBp1fc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);